import React, {useCallback, useEffect, useState} from "react";
import {BaseQueryParams, IdAziendaParams} from "@commons/utils/APIParams";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {LavoratoreFilterSelection} from "@commons/features/lavoratore/RMLLavoratore.api";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import {PaginationReturnType} from "@components/dataTable/usePagination";

export function normalizeStr(str: string | null | undefined): string {
    if (str) {
        const stringa = '' + str;
        return (stringa.toLowerCase().trim());
    }
    return '';
}

export function useQueryFilter<T extends BaseQueryParams>(def: T, pagination: PaginationReturnType) {
    const [filter, setFilter] = useState<T>(def);

    const start = pagination.getStart();
    const search = pagination.getSearchParams();
    useEffect(() => {

    }, [def]);

    useEffect(() => {
        if (pagination.serverSide) {
            // vedi https://stackoverflow.com/questions/53715465/can-i-set-state-inside-a-useeffect-hook
            setFilter(filter => ({
                ...filter,
                start: start,
                length: pagination.pageLength,
                mode: "DataTables",
                view: "Grid",
                search: search
            }));
        } else {
            setFilter(filter => ({
                ...filter,
                start: 0,
                length: 0,
                mode: "DataTables",
                view: "Grid",
            }));
        }
    }, [start, pagination.pageLength, search, pagination.serverSide]); // N.B. non mettere filter nelle dipendenze!

    return {filter, setFilter, skip: filter.mode ? false : true};
}

type UseEffectCB = ReturnType<typeof useCallback<(id: number | null) => void>>;

export function useSetIdAziendaTabelle<T extends IdAziendaParams = IdAziendaParams>(azienda: Pick<AziendaRecord, 'idAziendaCDIC'> | null, setFilter: React.Dispatch<React.SetStateAction<T>>, onEffect?: UseEffectCB) {
    const idAzienda = azienda ? azienda.idAziendaCDIC : null;
    useEffect(() => {
        if (idAzienda) {
            setFilter(filter => ({
                ...filter, idAzienda: idAzienda
            }));
        }
        if (onEffect)
            onEffect(idAzienda);
    }, [idAzienda, setFilter, onEffect])
}

export function useSetIdAziendaMaster<T extends IdAziendaParams = IdAziendaParams>(azienda: Pick<AziendaRecord, 'idAziendaMaster'> | null, setFilter: React.Dispatch<React.SetStateAction<T>>, onEffect?: UseEffectCB) {
    const idAziendaMaster = azienda ? azienda.idAziendaMaster : null;
    useEffect(() => {
        if (idAziendaMaster) {
            setFilter(filter => ({
                ...filter, idAziendaMaster: idAziendaMaster
            }));
        }
        if (onEffect)
            onEffect(idAziendaMaster);
    }, [idAziendaMaster, setFilter, onEffect])
}

export function useSetIdAzienda<T extends IdAziendaParams = IdAziendaParams>(azienda: Pick<AziendaRecord, 'idAzienda'> | null, setFilter: React.Dispatch<React.SetStateAction<T>>, onEffect?: UseEffectCB) {
    const idAzienda = azienda ? azienda.idAzienda : null;
    useEffect(() => {
        if (idAzienda) {
            setFilter(filter => ({
                ...filter, idAzienda: idAzienda
            }));
        }
        if (onEffect)
            onEffect(idAzienda);
    }, [idAzienda, setFilter, onEffect])
}


export function useSetIdDip<T extends LavoratoreFilterSelection = LavoratoreFilterSelection>(contratto: Pick<LavoratoreRecord, 'id'> | null | undefined, setFilter: React.Dispatch<React.SetStateAction<T>>, onEffect?: UseEffectCB) {
    const idDip = contratto ? contratto.id : null;
    useEffect(() => {
        if (idDip) {
            setFilter(filter => ({
                ...filter, idDip: idDip
            }));
        }
        if (onEffect)
            onEffect(idDip);
    }, [idDip, setFilter, onEffect])
}